import { Box, Typography } from "@mui/material";
import axios from "axios";
import { allOption, selectOptKeyName } from "data/globalData";
import { arrType, datatypes, inputTypes } from "data/globalData";
import { convertValueInCr } from "utils/roundDecimalValue";

export const blueShade = "#9fc5e8";
export const blueShade2 = "#cfe2f3";
export const blueShade3 = "#e2e9f0";

export const defRenderHeader = ({ col }) => {
	return <Box fontWeight={400}>{col?.name}</Box>;
};

export const ProjectionColumnHeader = ({ col }) => {
	return (
		<Box
			fontWeight={400}
			height="100%"
			width="100%"
			sx={{ background: blueShade2, display: "flex", justifyContent: "center", alignItems: "center" }}>
			{col?.name}
		</Box>
	);
};

export const defRenderCell = ({ row, field }) => {
	let sx = { width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" };
	if (row[brandColumn.key] === "units")
		sx = { width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" };
	return (
		<Box fontWeight={400} sx={sx}>
			{row[brandColumn.key] === "units" && field === brandColumn.key ? "" : row[field]}
		</Box>
	);
};
export const displayInCrRenderCell = ({ row, field }) => {
	let sx = { width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" };
	if (row[brandColumn.key] === "units")
		sx = { width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" };
	return (
		<Box fontWeight={400} sx={sx}>
			{row[brandColumn.key] === "units"
				? field === brandColumn.key
					? ""
					: row[field]
				: Number(row[field])
				? convertValueInCr(row[field])
				: 0}
		</Box>
	);
};
export const blueRenderCell = ({ row, field }) => {
	let sx = { background: blueShade3, display: "flex", justifyContent: "center", alignItems: "center" };
	if (row[brandColumn.key] === "units") sx = { display: "flex", justifyContent: "center", alignItems: "center" };
	return (
		<Box fontWeight={400} height="100%" width="100%" sx={sx}>
			{row[field]}
		</Box>
	);
};
export const achievedColumns = {
	aop: {
		name: "AOP",
		key: "aop",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		renderCell: displayInCrRenderCell,
		headerClassName: "default-header",
	},
	aop_ach: {
		name: "AOP ACH",
		key: "aop_ach",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		renderCell: displayInCrRenderCell,
		headerClassName: "default-header",
	},
	ach: {
		name: "ACH",
		key: "ach",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		renderCell: defRenderCell,
		headerClassName: "default-header",
	},
	gp_val: {
		name: "GP VAL",
		key: "gp_val",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		renderCell: displayInCrRenderCell,
		headerClassName: "default-header",
	},
	gp_percent: {
		name: "GP %",
		key: "gp_percent",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: defRenderHeader,
		renderCell: defRenderCell,
		headerClassName: "default-header",
	},
};

export const brandColumn = {
	name: "Brand",
	key: "brand",
	input_type: inputTypes.MULTIPLE_SELECT.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: "",
	select_options: {
		type: arrType,
		list: [
			// { name: allOption, key: allOption },
			{ name: "MAINLINE", key: "MAINLINE" },
			{ name: "GUILD", key: "GUILD" },
		],
	},
	renderHeader: defRenderHeader,
	renderCell: defRenderCell,
	headerClassName: "default-header",
};
export const channelColumn = {
	name: "Channel",
	key: "channel",
	input_type: inputTypes.MULTIPLE_SELECT.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: "",
	select_options: {
		type: arrType,
		list: [
			// { name: allOption, key: allOption },
			{ name: "MAINLINE", key: "MAINLINE" },
			{ name: "GUILD", key: "GUILD" },
		],
	},
	renderHeader: defRenderHeader,
	renderCell: defRenderCell,
	headerClassName: "default-header",
};
export const daysLeftColumn = {
	name: "Days Left",
	key: "days_left",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: "",
	renderHeader: ({ col }) => {
		return <Box fontWeight={600}>{col.name}</Box>;
	},
	renderCell: defRenderCell,
	headerClassName: "default-header",
};

export const projectionColumns = {
	projected_sales: {
		name: "REV",
		key: "projected_sales",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		headerClassName: "blue-header",
		renderHeader: ProjectionColumnHeader,
		renderCell: displayInCrRenderCell,
		editable: true,
	},

	projected_dis: {
		name: "DIS",
		key: "projected_dis",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: ProjectionColumnHeader,
		renderCell: defRenderCell,
		editable: true,
		headerClassName: "blue-header",
	},
	projected_gp_val: {
		name: "GP",
		key: "projected_gp_val",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderHeader: ProjectionColumnHeader,
		renderCell: displayInCrRenderCell,
		headerClassName: "blue-header",
	},
	projected_gp_percent: {
		name: "GP %",
		key: "projected_gp_percent",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderCell: defRenderCell,
		renderHeader: ProjectionColumnHeader,
		headerClassName: "blue-header",
	},
	projected_sale_per_day: {
		name: "SALE/DAY",
		key: "projected_sale_per_day",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		renderCell: displayInCrRenderCell,
		renderHeader: ProjectionColumnHeader,
		headerClassName: "blue-header",
	},
};

export const bqDataUpdateColumnsMap = {
	aop_ach: true,
	aop: true,
	gp_val: true,
};
export const sqlDataUpdateColumnsMap = {
	projected_sales: true,
	projected_gp_val: true,
};

export const unitRow = {
	brand: "units",
	aop: "INR CR",
	aop_ach: "INR CR",
	ach: "%",
	gp_val: "INR CR",
	gp_percent: "%",
	days_left: "#",
	projected_sales: "INR CR",
	projected_dis: "%",
	projected_gp_percent: "%",
	projected_gp_val: "INR CR",
	projected_sale_per_day: "INR CR",
};
export const staticBrandWiseData = [
	{
		brand: "THOR",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RR",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RSM",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RO",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
];
export const staticChannelWiseData = [
	{
		brand: "THOR",
		channel: "EBO",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "THOR",
		channel: "MBO",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "THOR",
		channel: "LFS",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RR",
		channel: "MP",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RR",
		channel: "MP-OR",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RR",
		channel: "CORP",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RR",
		channel: "D2C-INT",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RR",
		channel: "MP-INT",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RR",
		channel: "QC",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
];
export const staticCombinedData = [
	{
		brand: "THOR",
		channel: "EBO",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "THOR",
		channel: "MBO",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "THOR",
		channel: "LFS",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "THOR",
		channel: "MP",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "THOR",
		channel: "MP-OR",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "THOR",
		channel: "CORP",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "THOR",
		channel: "D2C-INT",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "THOR",
		channel: "MP-INT",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "THOR",
		channel: "QC",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RR",
		channel: "EBO",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RR",
		channel: "MBO",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RR",
		channel: "LFS",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RR",
		channel: "MP",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RR",
		channel: "MP-OR",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RR",
		channel: "CORP",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RR",
		channel: "D2C-INT",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RR",
		channel: "MP-INT",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
	{
		brand: "RR",
		channel: "QC",
		aop: "30",
		aop_ach: "30",
		ach: "98",
		gp_val: "26",
		gp_percent: "98",
		days_left: "17",
		projected_sales: "29",
		projected_dis: "98",
		projected_gp_percent: "98",
		projected_gp_val: "29",
		projected_sale_per_day: "98",
	},
];
